module.exports = __webpack_public_path__ + "img/comic3.jpg";